import { BaseRestResource } from "../../../../infrastructure/BaseRestResource";
import httpResource from "../../../core/infrastructure/httpResource";

class AuthClaimsResource extends BaseRestResource {
    constructor() {
        super(httpResource, 'auth_claims');
    }
}

const authClaimsResource = new AuthClaimsResource();

export default authClaimsResource;